import PropTypes from 'prop-types';

import FundingPage from '../funding/index';

const BusinessLineOfCredit = ({ location: { pathname: urlPath } }) => {
  return FundingPage({ location: { pathname: urlPath }, noIndex: false });
};

FundingPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
};

export default BusinessLineOfCredit;
